import * as React from 'react';

import { useRecommendedPackages } from './hooks';

import { DefaultPublication } from './components/DefaultPublication';
import { RecommendedPackage } from './components/RecommendedPackage';
import { RecommendedPackageHint } from './components/RecommendedPackageHint';
import { RecommendedPackageLayout } from './components/RecommendedPackageLayout';

export const RecommendedPackagesContainer = () => {
  const {
    isRender,
    isMobile,
    offerPrice,
    recommendedPackages,
    selectedRecommendedPackageId,
    handleDefaultPublicationClick,
    handleRecommendedPackageClick,
  } = useRecommendedPackages();

  if (!isRender) {
    return null;
  }

  return (
    <>
      <DefaultPublication
        price={offerPrice}
        isMobile={isMobile}
        selected={!selectedRecommendedPackageId}
        handleClick={handleDefaultPublicationClick}
      />

      {recommendedPackages.map(recommendedPackage => (
        <RecommendedPackageLayout
          key={recommendedPackage.packageId}
          recommendedPackage={
            <RecommendedPackage
              isMobile={isMobile}
              headerText={recommendedPackage.headerText}
              offersCount={recommendedPackage.totalAnnouncementsCount}
              auctionPointsCount={recommendedPackage.totalAuctionPointsCount}
              discountPercent={recommendedPackage.discountPercent}
              marketingPrice={recommendedPackage.marketingPrice}
              packagePrice={recommendedPackage.price}
              pricePerOffer={recommendedPackage.announcementPrice}
              selected={recommendedPackage.packageId === selectedRecommendedPackageId}
              handleClick={() => handleRecommendedPackageClick(recommendedPackage)}
            />
          }
          recommendedPackageHint={<RecommendedPackageHint isMobile={isMobile} text={recommendedPackage.tooltipText} />}
        />
      ))}
    </>
  );
};
